<template>
	<div class="login-guide-box">
		<span class="login-text">若您已有简历，可直接登录</span>
		<a class="login-btn" @click="login">登录</a>
	</div>
</template>
<script>
import util from '../../../util';
export default {
	methods: {
		login() {
			window.clickLog &&
				window.clickLog('from=fillout_micro_loginclk_new');
			let _fromurl = util.getParamVal('from');
			window.location.href = '//m.m.58.com/login/?path=' + encodeURIComponent(_fromurl);
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../assets/style/public.scss';
.login-guide-box {
	background: #fff0e8;
	height: px2rem(88px);
	line-height: px2rem(88px);
	text-align: center;
	font-size: px2rem(26px);
	color: $orange;
	clear: both;
}
.login-btn {
	border: 1px solid $orange;
	border-radius: 2px;
	padding: px2rem(4px) px2rem(34px);
	margin-left: px2rem(24px);
}
</style>



// WEBPACK FOOTER //
// index.vue?2195eb06